// removed by extract-text-webpack-plugin
module.exports = {"binary_cropper_dialog":"_3-h3wQYu9fZ169F1YNRlL8"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryCropTool/BinaryCropTool.scss
// module id = 2245
// module chunks = 1